
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { SystemQuery } from 'enums/SystemQuery';
import { Model, ModelProperty } from 'models/Model';


export class GetResultFromSystemQueryRequestModel extends Model<GetResultFromSystemQueryRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'systemQuery', type: 'SystemQuery' },
		{ name: 'parameters', type: 'Record<string, any>', isArray: true, isDictionary: true }
	];
	[key: string]: any;
	
	public systemQuery: SystemQuery;
	public parameters: Record<string, any>;
    
	constructor(){
		super();
		this.systemQuery = 0;
		this.parameters = {};
		
	}
	getProperties(){
		return GetResultFromSystemQueryRequestModel.classProperties;
	}
}

